import React, { HTMLAttributes } from 'react';

import {
  Accordion, AccordionItem, Container, WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ParagraphFAQ as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphFAQProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphFAQ: React.FC<ParagraphFAQProps> = ({ entity }) => {
  const paragraphFAQ = entity.toJS();
  const title = paragraphFAQ.field_title[0]?.value;
  const body = paragraphFAQ.field_body[0]?.processed;
  const faqItems = paragraphFAQ.field_faq;

  const schema = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((faqItem) => ({
      '@type': 'Question',
      name: faqItem.entity.title[0].value,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faqItem.entity.body[0].processed,
      },
    })),
  });

  return (
    <>
      <script type="application/ld+json">
        {schema}
      </script>

      <div className="Paragraph ParagraphFAQ">

        <Container>
          <div className="row">
            {title && (
              <h2 className="ParagraphFAQ__title col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">{title}</h2>
            )}
            {body && (
              <WysiwygField
                className="ParagraphFAQ__body col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2"
                property="schema:text"
                html={body}
              />
            )}
          </div>

          <Accordion>
            <div className="row">
              <div className="ParagraphFAQ__accordion col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                {faqItems.map((faqItem) => (
                  <AccordionItem
                    key={faqItem.target_id}
                    title={(<WysiwygField html={faqItem.entity.title[0].value} />)}
                    iconClassName="icon-expand_less icon-variant-0"
                    content={(
                      <WysiwygField html={faqItem.entity.body[0].processed} />
                    )}
                  />
                ))}
              </div>
            </div>
          </Accordion>
        </Container>
      </div>
    </>
  );
};

export default ParagraphFAQ;
